import { useEffect, useState } from "react";
import api from "@/lib/api";
import { formatFee } from "@/lib/format";

export default function DashPayments() {
  const [pays, setPays] = useState([]);
  useEffect(() => { api.get("/institution/payments").then((r) => setPays(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <h1 className="mb-1 font-heading text-2xl font-bold tracking-tight text-slate-900">Payments</h1>
      <p className="mb-6 text-sm text-slate-500">Your subscription payment history</p>
      {pays.length === 0 ? (
        <div className="rounded-xl border border-dashed border-slate-300 bg-white p-12 text-center text-slate-500">No payments yet.</div>
      ) : (
        <div className="overflow-x-auto rounded-xl border border-slate-200 bg-white">
          <table className="w-full min-w-[600px] text-left text-sm">
            <thead className="bg-slate-50 text-slate-500">
              <tr>
                <th className="p-3">Date</th><th className="p-3">Plan</th><th className="p-3">Gateway</th>
                <th className="p-3">Amount</th><th className="p-3">Expiry</th><th className="p-3">Status</th>
              </tr>
            </thead>
            <tbody>
              {pays.map((p) => (
                <tr key={p.id} className="border-t border-slate-100">
                  <td className="p-3">{(p.payment_date || "").slice(0, 10)}</td>
                  <td className="p-3 capitalize">{p.plan}</td>
                  <td className="p-3 capitalize">{p.gateway}</td>
                  <td className="p-3 font-medium">{formatFee(p.amount, p.currency)}</td>
                  <td className="p-3">{(p.subscription_expiry || "").slice(0, 10)}</td>
                  <td className="p-3"><span className="rounded-full bg-green-50 px-2 py-0.5 text-xs font-medium text-green-700 capitalize">{p.payment_status}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
